export enum FlowerPot {
  PINK = "PINK",
  YELLOW = "YELLOW",
  WHITE = "WHITE",
  BLUE = "BLUE",
  ORANGE = "ORANGE"
}

export const FlowerPots = [
  FlowerPot.PINK,
  FlowerPot.YELLOW,
  FlowerPot.WHITE,
  FlowerPot.BLUE,
  FlowerPot.ORANGE
] as const
